import type { AppSchema } from "instant.schema";
import type { InstaQLEntity } from "@instantdb/react";

export const SCHEMA_NAMES = {
  healthAreas: "healthAreas",
  goals: "goals",
  routines: "routines",
} as const;

export type SchemaNames = keyof typeof SCHEMA_NAMES;

export type User = InstaQLEntity<AppSchema, "users">;
export type HealthArea = InstaQLEntity<AppSchema, "healthAreas">;
export type Goal = InstaQLEntity<AppSchema, "goals">;
export type Routine = InstaQLEntity<AppSchema, "routines"> & {
  daysCompleted?: DaysCompleted[];
};
export type DaysCompleted = InstaQLEntity<AppSchema, "daysCompleted">;
export type NewsletterSignup = InstaQLEntity<AppSchema, "newsletter">;
